export interface AMLUser {
  AML_MSG: string
  AML_OperType: string
  AuthDate: string
  AuthLevel: number
  Author: string
  AuthorID: number
  Authorizer: string
  AuthorizerID: number
  CardNumber: string
  CheckDate: string
  ClientID: number
  DocDate: string
  FullName: string
  HashSum_UNSLID_: string
  ID: number
  IND_Name: string
  IND_Surname: string
  MTAgent: string
  Match_Percentage: number
  OtherIDNumber: string
  Terr_DataID: number
  Terr_FullName: string
  Terr_PassportID: number
}

export type AMLUsersServerData = AMLUser[]

export enum AMLServiceErrorCode {
  GENERAL,
}

export enum AMLAction {
  Unsl = 'unsl',
  Zone = 'zone',
  External = 'external',
  RiskOper = 'riskoper',
  Alert = 'alerts',
  CRA = 'cra',
  RiskLevels = 'risklevels',
}

export interface UnslJournalAttributes {
  Auth: number
  UNSLID: number
  HashSum_UNSLID_: string
}

export interface ZoneJournalAttributes {
  Auth: number
  ZoneID: number
  HashSum_ZoneID_: string
}

export interface ExternalJournalAttributes {
  Auth: number
  LogExternalID?: number
  HashSum_LogExternalID_?: string
}

export interface RiskOperJournalAttributes {
  Auth: number
  AMLRiskOperID: number
  HashSum_AMLRiskOperID_: string
  LogExternalID?: number
  HashSum_LogExternalID_?: string
}

export interface RiskLevelsJournalAttributes {
  Auth: number
  LogExternalID: number
  HashSum_LogExternalID_: string
}

export interface AddToJournalFailure {
  message: string
}
